import RankingSalesReportActions from "./actions";

const INITIAL_STATE = {
  data: null,
  isProcessing: false,
  isError: false,
  errorMessage: [],
  isNewRecord: false,
  showModal: false,
  onSubmit: false,
  single: null,
  helperRankingSalesReport: [],
  errorInternal: false,
};

function RankingSalesReportReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RankingSalesReportActions.RESET_LIST:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        single: null,
        form: INITIAL_STATE.form,
        data: {},
      };
    case RankingSalesReportActions.NEW_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        single: null,
        errorMessage: [],
        form: INITIAL_STATE.form,
        isNewRecord: true,
        showModal: true,
      };
    case RankingSalesReportActions.UPDATE_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        single: null,
        isNewRecord: false,
      };
    case RankingSalesReportActions.VIEW_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        single: action.payload,
        errorMessage: [],
        isNewRecord: false,
        showModal: true,
      };
    case RankingSalesReportActions.RESET_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        form: INITIAL_STATE.form,
        showModal: false,
      };
    case RankingSalesReportActions.DELETE_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        form: INITIAL_STATE.form,
        showModal: false,
      };
    case RankingSalesReportActions.ON_SUBMIT:
      return { ...state, errorInternal: false, onSubmit: true };
    case RankingSalesReportActions.SHOW_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isError: false,
        data: action.payload,
        errorMessage: [],
        isProcessing: false,
      };
    case RankingSalesReportActions.ERROR_DATA:
      return {
        ...state,
        errorInternal: false,
        isError: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };
    case RankingSalesReportActions.SUCCESS_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isError: false,
        showModal: false,
        form: INITIAL_STATE.form,
        onSubmit: false,
        isProcessing: false,
      };
    case RankingSalesReportActions.PROCESS_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: true,
        isError: false,
        isSuccess: false,
      };
    case RankingSalesReportActions.GET_HELPER_RANKINGSALES:
      return {
        ...state,
        errorInternal: false,
        isError: false,
        isSuccess: false,
        onSubmit: false,
        helperRankingSalesReport: action.payload,
      };
    case RankingSalesReportActions.ERROR_SERVER:
      return {
        ...state,
        isError: false,
        errorInternal: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };
    default:
      return state;
  }
}

export default RankingSalesReportReducer;
